<div
	class="card card-rank card-rank--sort-table tdt-card"
	[class.tdt-card--fill]="stackedHeader || showFooter"
	[class.tdt-card--searchable]="searchable"
	[ngClass]="cardExtraClass || null">
	<div class="card-head" [class.card-head--stacked]="stackedHeader || searchable">
		<div class="card-head__top">
			<div class="tdt-card__title-wrap">
				<i *ngIf="icon" [class]="icon + ' tdt-card__icon'" aria-hidden="true"></i>
				<div class="card-title">{{ cardTitle }}</div>
			</div>
			<div class="card-actions">
				<ng-content select="[tdtHeaderActions]"></ng-content>
				<span *ngIf="badgeLabel" class="badge tdt-card__badge">{{ badgeLabel }}</span>
				<button
					*ngIf="showClearFilter"
					type="button"
					class="btn btn-ghost danger"
					(click)="clearFilter.emit()"
					[attr.aria-label]="clearFilterAriaLabel">
					<i class="feather icon-x" aria-hidden="true"></i>
				</button>
			</div>
		</div>
		<div class="card-head__search" [hidden]="!stackedHeader && !searchable">
			<ng-content select="[tdtHeaderSearch]"></ng-content>
			<input
				*ngIf="searchable"
				type="text"
				class="form-control form-control-sm tdt-search"
				placeholder="Buscar..."
				aria-label="Buscar nesta lista"
				[(ngModel)]="searchTerm" />
		</div>
	</div>

	<div
		#scrollHost
		class="card-body scroll card-body--flush"
		[class.card-body--loading]="loading">
		<div *ngIf="loading" class="tdt-card__state tdt-card__state--loading">
			<span class="spinner-border spinner-border-sm text-primary mr-50"></span>
			<span>Carregando...</span>
		</div>

		<ng-container *ngIf="!loading && projectBody">
			<ng-content></ng-content>
		</ng-container>

		<table
			*ngIf="!loading && !projectBody && displayRows.length"
			class="table table-sm table-borderless mb-0 ct-sort-table tdt-table">
			<thead>
				<tr>
					<th
						*ngFor="let col of columns"
						scope="col"
						class="ct-sort-th"
						[class.ct-col--fill]="col.fill === true"
						[class.ct-col--shrink]="col.fill !== true"
						[class.text-right]="col.alignEnd"
						[attr.title]="col.tooltip || null">
						<button
							*ngIf="sortable"
							type="button"
							class="ct-sort"
							[class.ct-sort--end]="col.alignEnd"
							[class.ct-sort--active]="headerSortState(col.key) !== 'none'"
							(click)="onSortClick(col.key)"
							[attr.aria-sort]="ariaSort(col.key)">
							<span class="ct-sort__label">{{ col.label }}</span>
							<span class="ct-sort__icons" aria-hidden="true">
								<ng-container *ngIf="headerSortState(col.key) === 'none'">
									<i
										[inner]="true"
										[data-feather]="'chevron-up'"
										[size]="11"
										class="ct-sort__chev"></i>
									<i
										[inner]="true"
										[data-feather]="'chevron-down'"
										[size]="11"
										class="ct-sort__chev"></i>
								</ng-container>
								<i
									*ngIf="headerSortState(col.key) === 'asc'"
									[inner]="true"
									[data-feather]="'chevron-up'"
									[size]="14"></i>
								<i
									*ngIf="headerSortState(col.key) === 'desc'"
									[inner]="true"
									[data-feather]="'chevron-down'"
									[size]="14"></i>
							</span>
						</button>
						<span *ngIf="!sortable" class="tdt-th-label">{{ col.label }}</span>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let row of displayRows; trackBy: trackByKey"
					class="ct-sort-row"
					[ngClass]="rowClass(row)"
					[attr.tabindex]="isSelectable && row.key ? 0 : null"
					[attr.role]="isSelectable && row.key ? 'button' : null"
					(click)="onRowClick(row)"
					(keydown)="onRowKeydown($event, row)">
					<td
						*ngFor="let col of columns"
						[class.text-right]="col.alignEnd"
						[class.ct-col--fill]="col.fill === true"
						[class.ct-col--shrink]="col.fill !== true"
						[class.tdt-col-name]="col.key === 'name'"
						[ngClass]="cellToneClass(col, row)"
						[attr.title]="col.key === 'name' ? formatCell(col, row) : null">
						{{ formatCell(col, row) }}
					</td>
				</tr>
			</tbody>
		</table>

		<div
			*ngIf="!loading && !projectBody && !displayRows.length"
			class="tdt-card__state text-muted">
			{{ emptyMessage }}
		</div>

		<div
			*ngIf="!loading && hasMoreRows"
			#scrollSentinel
			class="tdt-scroll-sentinel"
			aria-hidden="true"></div>
	</div>

	<div class="tdt-card__footer" *ngIf="showFooter && footerTemplate">
		<ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
	</div>
</div>
